import styled from 'styled-components'

import FICColors from '../../common/FICColors'

export const FeedbackContainer = styled.div`
  padding: 24px 0 0;
  border-top: 1px solid rgba(51, 51, 51, 0.08);
  h3 {
    font-size: 18px;
    font-weight: bold;
    line-height: 32px;
    text-align: center;
    margin: 0;
    color: ${FICColors.textDefault};
  }
`
export const FeedbackButtons = styled.div`
  text-align: center;
  margin: 24px auto;
`
export const FeedbackComment = styled.div<{ valid: boolean }>`
  padding-bottom: 38px;
  .fic-input-text-input {
    width: 100%;
    height: 140px !important;
    margin-bottom: 16px;
    box-sizing: border-box;
  }
`
